export const textPopups = {
  // 15232 : "Dal 26 Aprile vi aspettiamo nella nostra nuova sede in via P.Mascagni 2/A a Gatteo a Mare"
};

export const maintenancePopup = {
  enabled: true,
  title: 'Manutenzione programmata',
  html: 'Nel corso della giornata il sito sarà interessato da <b>interventi di manutenzione programmata</b>.<br><br>' +
    'Durante questo periodo, alcuni contenuti e funzionalità del sito potrebbero risultare temporaneamente non disponibili.',
};
